import BlurryBackgroundContext from '@contexts/blurryBackground'
import { useContext } from 'react'

const useHasBlurryBackground = (): boolean =>
  !!useContext(BlurryBackgroundContext)

export default useHasBlurryBackground
